export default class PredefinedAnswer {

  constructor() {
    this.value = ''
  }

}
